export const similarMatchParameter = [
    "slim",
    "regular",
    "casual",
    "checked",
    "printed",
    "faded",
    "floral",
    "denim"
]